import { assignmentIds, localDay } from './taskFilters.js'

const DAY = 86400000
export function dayNumber(value) {
  if (!value) return null
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day ? date.getTime() / DAY : null
}
export function dayDate(number) {
  const date = new Date(number * DAY)
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12)
}
export function scheduleWindow(anchor, mode) {
  const date = dayDate(anchor)
  const first = mode === 'month' ? dayNumber(`${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-01`) : anchor
  const start = first - (dayDate(first).getDay() + 6) % 7
  if (mode !== 'month') return { start, length: mode === 'timeline' ? 42 : 7 }
  const last = first + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate() - 1
  return { start, length: Math.ceil((last - start + 1) / 7) * 7 }
}
export function scheduleTask(task, now = new Date()) {
  const sourceStart = dayNumber(task.startDateTime ? localDay(task.startDateTime) : null)
  const due = dayNumber(task.dueDateTime ? localDay(task.dueDateTime) : null)
  const start = sourceStart ?? due
  const plannedEnd = due ?? sourceStart
  const invalid = start !== null && plannedEnd !== null && start > plannedEnd
  const progress = Math.min(100, Math.max(0, Number(task.percentComplete) || 0))
  const today = dayNumber(localDay(now))
  const late = !invalid && due !== null && progress < 100 && due < today
  return { task, start, due, plannedEnd, end: late ? today : plannedEnd, dated: start !== null && !invalid, invalid, late, progress }
}
export function packLanes(items, window) {
  const lanes = []
  return items.filter(item => item.dated && item.start < window.start + window.length && item.end >= window.start)
    .map(item => ({ ...item, offset: Math.max(item.start,window.start)-window.start, length: Math.min(item.end,window.start+window.length-1)-Math.max(item.start,window.start)+1 }))
    .sort((a,b) => a.offset-b.offset)
    .map(item => {
      let lane = lanes.findIndex(end => end < item.offset)
      if (lane < 0) lane = lanes.length
      lanes[lane] = item.offset + item.length - 1
      return { ...item, lane }
    })
}
export function findOverlaps(items) {
  const people = new Map()
  for (const item of items.filter(item => item.dated && item.progress < 100)) {
    for (const person of assignmentIds(item.task)) {
      if (!people.has(person)) people.set(person, [])
      people.get(person).push(item)
    }
  }
  const overlaps = []
  for (const [person, tasks] of people) {
    tasks.sort((a,b) => a.start-b.start)
    for (let i=0; i<tasks.length; i++) {
      for (let j=i+1; j<tasks.length && tasks[j].start <= tasks[i].end; j++) {
        const a=tasks[i], b=tasks[j]
        if (a.task.board.id === b.task.board.id) continue
        overlaps.push({ person, a, b, from: b.start, to: Math.min(a.end,b.end) })
      }
    }
  }
  return overlaps
}
export function weekNumber(day) {
  const date = new Date(day * DAY)
  date.setUTCDate(date.getUTCDate() + 3 - (date.getUTCDay()+6)%7)
  return 1 + Math.round((date.getTime() - Date.UTC(date.getUTCFullYear(),0,4) - (3-(new Date(Date.UTC(date.getUTCFullYear(),0,4)).getUTCDay()+6)%7)*DAY) / (7*DAY))
}
